/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";
import TextField from "components/text-field/text-field";
import { Integrations, GoogleIndexingConfig, IntegrationConfig } from "api/integrations";
import TextArea from "components/text-area/text-area";
import { getErrorMessage } from "../validate";

interface Props {
  integration: { key: Integrations.GoogleIndexing; value: GoogleIndexingConfig };
  updateIntegrationField: (key: string, value: Object) => void;
  readOnly?: boolean;
  errors: Error | null;
  validateIntegration?: (integration: IntegrationConfig) => void;
}

const GoogleIndexing: React.FunctionComponent<Props> = ({ integration, updateIntegrationField, readOnly, errors }) => {
  const integrationName = integration.key;
  return (
    <React.Fragment>
      <TextField
        label={t("integrations.others.google-indexing.client-email")}
        value={integration.value["client-email"]}
        onChange={(value) => updateIntegrationField(integrationName, { "client-email": value })}
        readOnly={readOnly}
        errorMessage={getErrorMessage(integration.key, "client-email", errors)}
      />
      <TextArea
        label={t("integrations.others.google-indexing.private-key")}
        value={integration.value["private-key"]}
        onChange={(value) => !readOnly && updateIntegrationField(integrationName, { "private-key": value })}
        maxRows={10}
        errorMessage={getErrorMessage(integration.key, "private-key", errors)}
      />
    </React.Fragment>
  );
};

export default GoogleIndexing;
